var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }